
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Money } from 'v-money';

import { Row } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Row,
    Money
  }
})
export default class PortabilityValue extends Vue {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Number, required: true })
  private quantity!: number;

  @Prop({ type: Number, required: true })
  private value!: number;

  @Prop({ type: Number, required: true })
  private executedPrice!: number;

  private inputValue = 0;

  created() {
    this.inputValue = this.executedPrice;
  }
}
